module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-01-ee576b7457360eb3e01e2e0396139f77.jpg";